import { render, staticRenderFns } from "./TopContributors.vue?vue&type=template&id=701c1506&scoped=true"
import script from "./TopContributors.vue?vue&type=script&lang=js"
export * from "./TopContributors.vue?vue&type=script&lang=js"
import style0 from "./TopContributors.vue?vue&type=style&index=0&id=701c1506&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701c1506",
  null
  
)

export default component.exports